import { render, staticRenderFns } from "./bom.vue?vue&type=template&id=5ae999ca&scoped=true"
import script from "./bom.vue?vue&type=script&lang=js"
export * from "./bom.vue?vue&type=script&lang=js"
import style0 from "./bom.vue?vue&type=style&index=0&id=5ae999ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae999ca",
  null
  
)

export default component.exports